import React, { useState } from "react";
import { connect } from "react-redux";
import { toKebabCase } from "../../../../helpers/cssHelper";
import TinyEditor from "../../../components/plugins/tiny_plugin/TinyEditor";
/* import './TextArea.css' */

const TextWrapper = (props) => {
  const { text, textOnChange, selectedElement, template, contentId, element, elementStyle = null } = props;
  let selectedStyles = {};
  if (template && template.content) {
    const { title, a, subtitle, label, table, thead, tcell } = template.content;
    selectedStyles = { title, a, subtitle, label, table, thead, tcell };
  }
  return (
    <React.Fragment>
      <table>
        <tbody>
          <tr>
            <td className="styleWrapper">
              {template ? (
                <style>
                  {`
                 
                  ${toKebabCase(selectedStyles, true, false)}
                  .styleWrapper a{
                    font-family: ${elementStyle ? elementStyle.fontFamily : ""}
                  }
                  .styleWrapper td{
                    font-family: ${elementStyle ? elementStyle.fontFamily : ""}
                  }
                  `}
                </style>
              ) : null}
              <TinyEditor element={element} contentId={contentId} linkColor={selectedStyles?.a?.color} value={text} editMode={true} onChange={textOnChange} user={null} />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    selectedElement: state.email.selectedElement,
    template: state.template.template,
  };
}

export default connect(mapStateToProps)(TextWrapper);
